import {PayPerUseMetricsResponse} from '@dms/api/settings';

import {isHiddenOperation} from './isHiddenOperation';

/**
 * `metrics.previousTotalCount` with the hidden operations' previous-window
 * counts subtracted out, so the total-operations trend compares visible-only
 * totals across periods.
 */
export const getVisiblePreviousTotalCount = (metrics: PayPerUseMetricsResponse): number =>
  metrics.operationTypes
    .filter(isHiddenOperation)
    .reduce((total, operation) => total - operation.previousCount, metrics.previousTotalCount);
